/*
 *  Seedlist functionality
 *
 *
 */

var seedlist_ids = [];







jQuery(document).ready(function() {

  loadSeedlist();


  // Initialize compare list from cookie
  var json_str = readCookie('seedlist_ids');
  if (json_str !== null) {
    seedlist_ids = JSON.parse(json_str);
  }

  // If there is some ids stored, show the UI.
  if (seedlist_ids !== null && seedlist_ids.length > 0) {
    console.log('Has seed list!');
  }


  // When a facet refreshes, show which products are in list
  jQuery(document).on('facetwp-loaded', function() {
    initializeSeedlist();
    updateProductSeedList();
  });


  // Save seedlist link
  jQuery('a.save-seedlist-link').on('click', function() {
    // Save a cookie.
    createCookie('redirect_to_seedlist', 1, .25);
    console.log('redirect');
  });

});






function loadSeedlist() {

}


function initializeSeedlist() {

  // Add or remove item to compare list
  jQuery(".seedlist-add").on("click", function(e) {
    var id = jQuery(this).attr('data-id');

    // If it's not in the list, add it.
    if (!seedlist_ids.includes(id)) {

      console.log(seedlist_ids);

      seedlist_ids.push(id);
      console.log('Adding....');
      console.log(seedlist_ids);

      // Ajax add a product ID.
      if (vars.user_id > 0) {
        syncSeedlist();
      }

      updateProductSeedList();



    } else {
      var index = seedlist_ids.indexOf(id);
      if (index > -1) {
        seedlist_ids.splice(index, 1);
        console.log('removing seed list entry');
      }
      /// Ajax remove a product ID.

      syncSeedlist();


      updateProductSeedList();
    }

    // Create/update cookie.
    var json_str = JSON.stringify(seedlist_ids);
    createCookie('seedlist_ids', json_str, 3);
  });



  // Clicking on compare button
  jQuery("#seedlist-link").on("click", function(e) {

    if (vars.user_id <= 0 || 1) {
      console.log('HERE clicked.' + vars.user_id);
      var ids_str = seedlist_ids.join(',');
      window.location.href = '/my-seedlist?ids=' + ids_str;
      return false;
    }

  });

}



function syncSeedlist() {
  jQuery.ajax({
    type: "post",
    dataType: "json",
    url: vars.ajaxurl,
    data: {
      action: "seedlist_sync",
      seedlist_ids: JSON.stringify(seedlist_ids),
    },
    success: function(response) {
      if (response) {
        console.log('Product added to seed list');
        console.log(response);
      } else {
        console.log('Error adding product to seed list: ' + response);
      }
    },
    error: function(errorThrown) {
      console.log('ERROR: ' + errorThrown);
    }
  });
}


function updateProductSeedList() {
  jQuery('ul.products li').each(function() {
    var id = jQuery(this).find('button.seedlist-add').attr('data-id');
    if (seedlist_ids.includes(id)) {
      jQuery(this).find('button.seedlist-add').addClass('selected');
      jQuery(this).find('button.seedlist-add').html('- Remove from seed list');
    } else {
      jQuery(this).find('button.seedlist-add').removeClass('selected');
      jQuery(this).find('button.seedlist-add').html('+ Add to Seed List');
    }
  });
}